/**
 * CirurgiasInfoModal - Modal informativo para formato de Excel de Cirurgias
 */
import React from 'react';
import { Info, X } from 'lucide-react';

interface CirurgiasInfoModalProps {
  onClose: () => void;
}

export const CirurgiasInfoModal: React.FC<CirurgiasInfoModalProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-2xl w-full">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-600 to-emerald-600 px-6 py-4 rounded-t-xl flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <Info className="text-white" size={24} />
            <h3 className="text-lg font-semibold text-white">
              Formato do Excel - Cirurgias a Faturar
            </h3>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 rounded-lg p-1 transition"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 p-4 rounded mb-4">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
              📋 Colunas Obrigatórias
            </h3>
            <p className="text-sm text-gray-700 dark:text-gray-300 mb-3">
              O arquivo Excel deve conter <strong>8 colunas</strong> (nesta ordem exata):
            </p>
            <ol className="text-sm text-gray-700 dark:text-gray-300 space-y-2 list-decimal list-inside">
              <li><strong>DATA/HORA</strong> (DD/MM/AAAA HH:MM)</li>
              <li><strong>PACIENTE</strong> (Nome do paciente)</li>
              <li><strong>MEDICO</strong> (Nome do médico)</li>
              <li><strong>CONVENIO</strong> (Convênio/Plano)</li>
              <li><strong>CODIGO PRODUTO</strong> (Código do item)</li>
              <li><strong>LOTE</strong> (Lote do produto)</li>
              <li><strong>QUANTIDADE</strong> (Número decimal, ex: 1 ou 1.5)</li>
              <li><strong>CNPJ</strong> (Opcional se selecionar cliente na importação)</li>
            </ol>
          </div>

          <div className="text-xs text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700 pt-4">
            <p>💡 <strong>Dica:</strong> Se você selecionar um cliente na tela de importação, o CNPJ da planilha será ignorado.</p>
          </div>

          {/* Footer */}
          <div className="mt-6 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-lg transition"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
